import { Info, AlertTriangle, CheckCircle, Lightbulb } from "lucide-react";

interface HighlightBoxProps {
  data: {
    type?: 'info' | 'warning' | 'success' | 'tip';
    title?: string;
    content: string;
  };
}

export const HighlightBox = ({ data }: HighlightBoxProps) => {
  const styles = {
    info: {
      bg: "bg-blue-50",
      border: "border-blue-100",
      icon: <Info className="w-5 h-5 text-blue-600" />,
      title: "text-blue-900",
      text: "text-blue-800"
    },
    warning: {
      bg: "bg-amber-50",
      border: "border-amber-100",
      icon: <AlertTriangle className="w-5 h-5 text-amber-600" />,
      title: "text-amber-900",
      text: "text-amber-800"
    },
    success: {
      bg: "bg-emerald-50",
      border: "border-emerald-100",
      icon: <CheckCircle className="w-5 h-5 text-emerald-600" />,
      title: "text-emerald-900",
      text: "text-emerald-800"
    },
    tip: {
      bg: "bg-violet-50",
      border: "border-violet-100",
      icon: <Lightbulb className="w-5 h-5 text-violet-600" />,
      title: "text-violet-900",
      text: "text-violet-800"
    }
  };

  const style = styles[data.type || 'info'];

  return (
    <div className={`my-6 rounded-xl border p-4 ${style.bg} ${style.border}`}>
      <div className="flex gap-3">
        <div className="flex-shrink-0 mt-0.5">
          {style.icon}
        </div>
        <div>
          {data.title && (
            <h4 className={`font-semibold text-sm mb-1 ${style.title}`}>
              {data.title}
            </h4>
          )}
          <div className={`text-sm leading-relaxed ${style.text}`}>
            {data.content}
          </div>
        </div>
      </div>
    </div>
  );
};
